// Swiper.jsx
import { useSwipeable } from 'react-swipeable';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSidebar } from '../components/SidebarContext.jsx';

const STRENGTH_DELTA = 80;

export default function Swiper({ children }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { setSidebarOpen } = useSidebar();

    const handlers = useSwipeable({
        onSwipedRight: () => {
            if (location.pathname === '/'){
                navigate('/resume');
                setSidebarOpen(false);
            } else if (location.pathname === '/projects') {
                navigate('/');
                setSidebarOpen(false);
            }
        },
        onSwipedLeft: () => {
            if (location.pathname === '/resume'){
                navigate('/');
                setSidebarOpen(false);
            } else if (location.pathname === '/'){
                navigate('/projects');
                setSidebarOpen(false);
            }
        },
        onSwipedUp:  ({ initial, deltaY }) => {
            const startY = initial[1]; // Y coordinate where the swipe started
            const screenHeight = window.innerHeight;

            const bottomThreshold = 100; // px from the bottom

            const startedNearBottom = startY > screenHeight - bottomThreshold;
            const strongSwipe = deltaY < STRENGTH_DELTA;

            if (startedNearBottom && strongSwipe) {
                setSidebarOpen(true);
            }
        },
        onSwipedDown: ({ deltaY }) => {
            if (deltaY > STRENGTH_DELTA) { // Only open menu on intentional swipe
                setSidebarOpen(false);
            }
        },
        preventScrollOnSwipe: false,
        trackTouch: true,
        trackMouse: false,
    });

    return (
        <div {...handlers} style={{ height: '100vh' }}>
            {children}
        </div>
    );
}
